
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 26","width":"30","height":"30","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.108 5.381a.608.608 0 00-.17-.417L14.465.375A.573.573 0 0014.054.2H1.63A1.248 1.248 0 00.4 1.462V24.54A1.248 1.248 0 001.63 25.8h16.246a1.248 1.248 0 001.232-1.261V5.388 5.38zm-4.47-3.134l2.476 2.541h-2.415a.062.062 0 01-.061-.063V2.247zm3.302 22.292a.062.062 0 01-.061.063H1.633a.062.062 0 01-.061-.063V1.462c0-.034.026-.063.06-.064h11.839V4.73a1.248 1.248 0 001.23 1.263h3.241v18.55l-.002-.003zM14.924 8.4H4.586a.6.6 0 000 1.198h10.338a.6.6 0 000-1.198zm0 3.616H4.586a.6.6 0 100 1.2h10.338a.6.6 0 000-1.202v.002zm0 3.618H4.586a.6.6 0 000 1.198h10.338a.6.6 0 000-1.198zm-5.17 3.616H4.587a.6.6 0 100 1.2h5.169a.6.6 0 10-.001-1.2z"}})])
          )
        }
      }
    